import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center text-ink-500" data-testid="auth-loading">
                <div className="font-mono text-xs tracking-widest uppercase">Loading…</div>
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }
    // Force first-time password change (partners enrolled via haevn.co).
    // Only redirect if not already on the change-password page to avoid loops.
    if (user.must_change_password && location.pathname !== "/change-password") {
        return <Navigate to="/change-password" replace />;
    }
    if (roles && roles.length && !roles.includes(user.role)) {
        return <Navigate to="/" replace />;
    }
    return children;
}
